export default __webpack_public_path__ + "static/animation-img6-7a80d8436f359c4e5efa995d60fd600c.webp";